'use client';

import useDynamicTranslation from '@/hooks/useDynamicTranslation';
import { Link } from '@/i18n/routing';
import { Article } from '@/types';

interface ArticleItemProps {
  article: Article;
}

export default function ArticleItem({ article }: ArticleItemProps) {
  const { dt } = useDynamicTranslation();

  return (
    <div style={{ position: 'relative' }}>
      <div className="md-img">
        <div className="img-container">
          <img className="image" src={article.image} alt={`article-image-${article.id}`} />
        </div>
        <div className="content-text">
          <span>
            <i className="fa fa-calendar-check-o"></i>
            {article.created_at}
          </span>
          <h5>{article.title}</h5>
          <Link href={`/articles/${article.id}/${article.slug}`}>
            {dt('show_more')}
            <i className="fa fa-arrow-left"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}
